// Widget Scripts
import cardWidgetQuickLinks from './js/widgets/cardWidgetQuickLinks.js';
import swiperWidgetEventMode from './js/widgets/swiperWidget.js';
import calendar from './js/widgets/calendar.js';
import hotButtons from './js/widgets/hotButtons.js';
import cardWidget from './js/widgets/cardWidget.js';
import seoWidget from './js/widgets/seoWidget.js';
import videoWidget from './js/widgets/videoWidget.js';
import scrollerSponsors from './js/widgets/scrollerSponsors.js';

// Custom Theme Scripts
import './js/localjs.js';
import './js/subpageHero.js';

// Initialize Homepage Widgets
if (window.location.pathname === '/') {
  $(document).ready(function () {
    if ($('body').hasClass('eventsMode')) {
      swiperWidgetEventMode('swiperWidgetEventMode', swiperWidgetEventModeOpts);
      calendar();
      hotButtons();
      cardWidget('cardWidgetEventMode', cardWidgetEventModeOpts);
      seoWidget('seoWidgetEventMode', seoWidgetEventModeOpts);
    } else {
      swiperWidgetEventMode('swiperWidget', swiperWidgetOpts);
      cardWidget('cardWidget', cardWidgetOpts);
      seoWidget('seoWidget', seoWidgetOpts);
    }
    scrollerSponsors();
  });

  $(window).load(function () {
    videoWidget();
  });
}

$(document).ready(function () {
  cardWidgetQuickLinks();
});
